// eslint-disable-next-line
export const BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE = 'BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE'
